import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Subscription } from 'rxjs'
import { filter } from 'rxjs/operators'

import { SalesPeriodsService } from '@/services/sales-periods.service'

import { SalesPeriod } from '@/domain/sales-period'

@UntilDestroy()
@Component({
  selector: 'sales-period-view',
  templateUrl: 'sales-period-view.component.html'
})
export class SalesPeriodViewComponent implements OnInit, OnDestroy {

  period: SalesPeriod = null

  private _subscription: Subscription
  private _navigatedToId: number = null

  constructor(
    public _service: SalesPeriodsService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._route.params.pipe(untilDestroyed(this)).subscribe(
      params => {
        const navigatedToId = +params['id']
        if (!this.period || navigatedToId != this.period.id) {
          this._navigatedToId = navigatedToId
          // Filter out null values to prevent clearing period during token refresh
          // Only update if we get a valid period, or if period is null and we don't have one yet
          this._subscription = this._service.watch(navigatedToId).pipe(
            filter(p => {
              // Allow null only if we don't have a period yet (initial load)
              // Once we have a period, ignore null emissions (which can happen during token refresh)
              // This prevents the period from being cleared during token refresh operations
              const shouldAllow = p !== null || this.period === null
              if (!shouldAllow && p === null) {
                console.warn('[SalesPeriodView] Ignoring null period emission - period already loaded, likely during token refresh')
              }
              return shouldAllow
            })
          ).subscribe(p => { 
            if (p !== null) {
              this.period = p
            }
            // Note: We intentionally don't set this.period = null here
            // because the filter above prevents null from reaching this point
            // once we have a period loaded
          })
        }
      }
    )
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe()
      this._navigatedToId = null
    }
  }
}